import { PropsWithChildren } from 'react';
import { CookiesProvider } from 'react-cookie';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'react-hot-toast';

import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import useTheme from '@repo/hooks/useTheme';
import { GlobalStyle, affiliateThemeByService, muiTheme } from '@repo/styles';
import { UIThemeProvider } from '@repo/ui/foundations';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import V2BrandVarsGlobal from './V2BrandVarsGlobal';
import ModalStackProvider from '../modal/ModalStackProvider';

export type OutletChildType = {
  device: { isMobile: boolean; isLaptop: boolean; isDesktop: boolean; isXLarge: boolean };
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      throwOnError: true,
      retry: 0,
      refetchOnWindowFocus: false,
      networkMode: 'always',
    },
    mutations: {
      throwOnError: true,
      networkMode: 'always',
    },
  },
});

const GlobalProvider = ({ children }: PropsWithChildren) => {
  const { theme } = useTheme(affiliateThemeByService(), { forceLightMode: true });
  const mui = muiTheme();

  return (
    <CookiesProvider>
      <QueryClientProvider client={queryClient}>
        <HelmetProvider>
          <MuiThemeProvider theme={mui}>
            <UIThemeProvider theme={theme}>
              <GlobalStyle />
              <V2BrandVarsGlobal />
              {children}
              <Toaster
                containerStyle={{
                  top: '50%',
                }}
              />
              <ModalStackProvider />
            </UIThemeProvider>
          </MuiThemeProvider>
        </HelmetProvider>
        <ReactQueryDevtools />
      </QueryClientProvider>
    </CookiesProvider>
  );
};

export default GlobalProvider;
